import { environment }         from '../config/environment';
import { Game }                from '../models/Game';
import { User }                from '../models/User';
import AuthService             from './AuthService';
import { LocalStorageService } from './LocalStorage';

class RecentlyPlayedGame {
    public game: Game;
    public date: number;

    constructor({ game, date }: Partial<RecentlyPlayedGame>) {
        this.game = new Game(game);
        this.date = date;
    }
}

class GamesStorage {
    public STORAGE_KEY: string = 'arkadium-recently-played-games';

    public read(): RecentlyPlayedGame[] {
        const data = JSON.parse(LocalStorageService.getItem(this.STORAGE_KEY)) || [];

        return data.map((item) => new RecentlyPlayedGame(item));
    }

    public dump(data: RecentlyPlayedGame[]) {
        LocalStorageService.setItem(this.STORAGE_KEY, JSON.stringify(data));
    }
}

const API_PATH = environment.USER_API + '/recently-played';

class RecentlyPlayedService {
    private storage: GamesStorage = new GamesStorage();

    public async read(games: Game[], user: User): Promise<Game[]> {
        if (!user) {
            return this.storage.read()
                .map((item) => item.game)
                .filter(g => games.find(game => game.slug === g.slug))
                .slice(0, 9);
        }

        return AuthService.authFetch(`${API_PATH}?takeCount=9`)
            .then(data => data.map(
                (item: string) => games.find(game => game.slug === item))
                .filter(g => !!g));
    }

    public trackGameStart(game: Game, user: User): Promise<string> {
        if (!user) {
            this.saveUnauthorized(game);
            return;
        }

        return AuthService.authFetch(`${API_PATH}`, {
            method: 'POST',
            body: JSON.stringify({ gameSlug: game.slug })
        }, false);
    }

    private saveUnauthorized(game: Game): Game[] {
        let playedGames = this.storage.read();
        const gameFromStorage = playedGames.find((item) => item.game.slug === game.slug);

        if (gameFromStorage) {
            gameFromStorage.date = Date.now();
        } else {
            playedGames.push(new RecentlyPlayedGame({
                game, date: Date.now(),
            }));
        }

        playedGames = playedGames.sort((a, b) => {
            return b.date - a.date;
        });

        this.storage.dump(playedGames);

        return playedGames.map((item) => item.game);
    }

    private saveToStore() {

    }
}

export default new RecentlyPlayedService();
